/* ELIO geo shipping strip.
   Runs as an external asset (inline section scripts are blocked on this theme).
   Reads its Liquid-computed copy from data- attributes on the strip element,
   resolves the visitor's city/state via ipgeolocation.io (CORS-enabled),
   and rewrites the ship line + struck price. Fails silent to the default line. */
(function () {
  function run() {
    // Config source: the PDP strip if present, otherwise a lightweight config element
    // (used on the cart, which has a struck price but no ship line).
    var strip = document.querySelector('[data-elio-ship-strip]');
    var cfgEl = strip || document.querySelector('[data-elio-geo-config]');
    if (!cfgEl) return;                       // nothing on this page needs geo
    // Ship LINE only lives inside the PDP strip. Scope the lookup to the strip so we
    // never touch the countdown's text element (which shares data-elio-ship-text) on the cart.
    var textEl = strip ? strip.querySelector('[data-elio-ship-text]') : null;

    var geoTemplate = cfgEl.getAttribute('data-geo-template') || 'Typically delivers to [city] in [range] business days.';
    var businessDays = cfgEl.getAttribute('data-business-days') || 'business days';
    var shopCountry = (cfgEl.getAttribute('data-shop-country') || '').trim().toUpperCase();
    var apiKey = cfgEl.getAttribute('data-geo-key') || '';

    var ZONE = {
      NY: '2 to 3', NJ: '2 to 3', CT: '2 to 3', PA: '2 to 3', MA: '2 to 3', RI: '2 to 3',
      DE: '2 to 3', MD: '2 to 3', DC: '2 to 3', NH: '2 to 3', VT: '2 to 3', ME: '2 to 3',
      VA: '2 to 4', WV: '2 to 4', OH: '2 to 4', NC: '2 to 4', SC: '2 to 4', IN: '2 to 4',
      MI: '2 to 4', KY: '2 to 4', GA: '2 to 4', TN: '2 to 4',
      IL: '4 to 6', WI: '4 to 6', MN: '4 to 6', IA: '4 to 6', MO: '4 to 6', AL: '4 to 6',
      MS: '4 to 6', AR: '4 to 6', LA: '4 to 6',
      TX: '4 to 6', OK: '4 to 6', KS: '4 to 6', NE: '4 to 6', ND: '4 to 6', SD: '4 to 6',
      CO: '4 to 6', NM: '4 to 6', MT: '4 to 6', WY: '4 to 6', FL: '4 to 6',
      CA: '4 to 6', WA: '4 to 6', OR: '4 to 6', NV: '4 to 6', AZ: '4 to 6', UT: '4 to 6', ID: '4 to 6',
      AK: '6 to 8', HI: '6 to 8',
      PR: '5 to 8', VI: '7 to 10', MX: '8 to 14'
    };

    var COST = {
      NY: '$5.95', NJ: '$5.95', CT: '$5.95', PA: '$5.95', MA: '$5.95', RI: '$5.95',
      DE: '$5.95', MD: '$5.95', DC: '$5.95', NH: '$5.95', VT: '$5.95', ME: '$5.95',
      VA: '$6.45', WV: '$6.45', OH: '$6.45', NC: '$6.45', SC: '$6.45', IN: '$6.45',
      MI: '$6.45', KY: '$6.45', GA: '$6.45', TN: '$6.45',
      IL: '$6.95', WI: '$6.95', MN: '$6.95', IA: '$6.95', MO: '$6.95', AL: '$6.95',
      MS: '$6.95', AR: '$6.95', LA: '$6.95',
      TX: '$7.45', OK: '$7.45', KS: '$7.45', NE: '$7.45', ND: '$7.45', SD: '$7.45',
      CO: '$7.45', NM: '$7.45', MT: '$7.45', WY: '$7.45', FL: '$7.45',
      CA: '$7.95', WA: '$7.95', OR: '$7.95', NV: '$7.95', AZ: '$7.95', UT: '$7.95', ID: '$7.95',
      AK: '$8.95', HI: '$8.95'
    };

    var NAME2ABBR = {
      ALABAMA: 'AL', ALASKA: 'AK', ARIZONA: 'AZ', ARKANSAS: 'AR', CALIFORNIA: 'CA',
      COLORADO: 'CO', CONNECTICUT: 'CT', DELAWARE: 'DE', FLORIDA: 'FL', GEORGIA: 'GA',
      HAWAII: 'HI', IDAHO: 'ID', ILLINOIS: 'IL', INDIANA: 'IN', IOWA: 'IA', KANSAS: 'KS',
      KENTUCKY: 'KY', LOUISIANA: 'LA', MAINE: 'ME', MARYLAND: 'MD', MASSACHUSETTS: 'MA',
      MICHIGAN: 'MI', MINNESOTA: 'MN', MISSISSIPPI: 'MS', MISSOURI: 'MO', MONTANA: 'MT',
      NEBRASKA: 'NE', NEVADA: 'NV', 'NEW HAMPSHIRE': 'NH', 'NEW JERSEY': 'NJ',
      'NEW MEXICO': 'NM', 'NEW YORK': 'NY', 'NORTH CAROLINA': 'NC', 'NORTH DAKOTA': 'ND',
      OHIO: 'OH', OKLAHOMA: 'OK', OREGON: 'OR', PENNSYLVANIA: 'PA', 'RHODE ISLAND': 'RI',
      'SOUTH CAROLINA': 'SC', 'SOUTH DAKOTA': 'SD', TENNESSEE: 'TN', TEXAS: 'TX', UTAH: 'UT',
      VERMONT: 'VT', VIRGINIA: 'VA', WASHINGTON: 'WA', 'WEST VIRGINIA': 'WV',
      WISCONSIN: 'WI', WYOMING: 'WY', 'DISTRICT OF COLUMBIA': 'DC',
      'PUERTO RICO': 'PR', 'U.S. VIRGIN ISLANDS': 'VI', 'US VIRGIN ISLANDS': 'VI'
    };

    function reveal() {
      if (strip) strip.classList.add('is-ship-ready');
    }

    function apply(city, region, country) {
      var ctry = String(country || '').trim().toUpperCase();
      var raw = String(region || '').trim().toUpperCase();
      var st = (raw.length === 2) ? raw : (NAME2ABBR[raw] || raw);
      // Mexico and the territories can come back as a country code OR as US + state.
      // Handle both: country code wins when it's MX/PR/VI, otherwise key off state.
      var key;
      if (ctry === 'MX' || ctry === 'PR' || ctry === 'VI') {
        key = ctry;
      } else {
        key = st;
      }
      var range = ZONE[key];
      if (!range) return;
      // Ship line: only where a line element exists (PDP). Cart has price only.
      if (textEl) {
        var place = (region && String(region).trim().length && String(region).trim().length <= 28)
          ? String(region).trim()
          : (key || null);
        if (place) {
          var line = geoTemplate.replace('[city]', place).replace('[state]', place).replace('[range]', range);
          var phrase = range + ' ' + businessDays;
          if (line.indexOf(phrase) !== -1) {
            line = line.split(phrase).join('<b>' + phrase + '</b>');
          }
          textEl.innerHTML = line;
        }
      }
      // Shipping COST is deliberately not rendered. A geo-guessed figure cannot
      // match what Shopify charges at checkout, and carts under the free-shipping
      // threshold are now actually billed, so a wrong number would be a broken
      // promise. Delivery TIME above is still shown: that one we can stand behind.
      reveal();
    }

    function applyCountryFloor() {
      if (shopCountry === 'MX') { apply(null, null, 'MX'); }
      reveal();
    }

    if (!apiKey) { applyCountryFloor(); return; }

    try {
      var ctrl = new AbortController();
      var t = setTimeout(function () { ctrl.abort(); }, 2500);
      fetch('https://api.ipgeolocation.io/ipgeo?apiKey=' + encodeURIComponent(apiKey) + '&fields=state_prov,country_code2', { signal: ctrl.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          clearTimeout(t);
          if (d && (d.state_prov || d.country_code2)) {
            apply(null, d.state_prov, d.country_code2);
          } else {
            applyCountryFloor();
          }
          reveal();
        })
        .catch(function () { applyCountryFloor(); reveal(); });
    } catch (e) { applyCountryFloor(); reveal(); }

    // Safety net: never leave the strip hidden, even if geo hangs past the timeout.
    setTimeout(reveal, 2800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Re-init hook. The PDP colorway swap replaces the section markup, which
     destroys the nodes this bound to. Geo results are already cached inside
     `run`, so re-running is cheap and makes no second network call. */
  window.elioShipStrip = window.elioShipStrip || {};
  window.elioShipStrip.refresh = run;
})();
